/* global window */
import { bool } from 'prop-types';
import { Button, Container } from 'react-bootstrap';
import React from 'react';
import '../styles/CartRecovery.css';


const CartRecovery = ({ isMobile }) => {
    const handleLogin = () => {
        window.location.assign('/login');
    };

    const handleContinueAsGuest = () => {
        window.location.assign('/');
    };

    return (<Container
        className={'mt-4'}>
        <h1
            className={'mb-3'}>Cart Recovery</h1>
        <div
            className={'cart-recovery--container'}>
            <div
                className={'cart-recovery--option-container'}>
                <p
                    className={'fs-4 text-center'}>CONTINUE SHOPPING</p>
                <p>
                    We noticed that your cart is already associated to your
                    account. Please login to continue shopping using your old
                    cart.
                </p>
                <Button
                    onClick={handleLogin}>Login</Button>
            </div>
            <div
                className={'cart-recovery--boundary'}>
                <div
                    className={'cart-recovery--boundary-line'} />
                <span
                    className={'fs-2'}>OR</span>
                <div
                    className={'cart-recovery--boundary-line'} />
            </div>
            <div
                className={'cart-recovery--option-container'}>
                <p
                    className={'fs-4 text-center'}>GET A NEW CART</p>
                <p>
                    You can continue shopping as a guest and get a new cart. Your
                    old cart will be discarded.
                </p>
                <Button
                    onClick={handleContinueAsGuest}>Continue</Button>
            </div>
        </div>
    </Container>);
};

CartRecovery.propTypes = {
    isMobile: bool,
};

export default CartRecovery;